var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewRxIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20854 6.91316C9.71493 6.37282 11.3406 6.14867 12.9352 6.30848C13.8472 6.40137 14.7489 6.60166 15.611 6.91359C17.1774 7.4437 18.6331 8.267 19.9703 9.23348C20.9147 9.92254 21.8044 10.6883 22.6115 11.5346C22.7368 11.6539 22.7986 11.8193 22.8182 11.9885V12.0251C22.7995 12.1956 22.7364 12.3626 22.6103 12.4828C21.7823 13.3491 20.8699 14.1345 19.8971 14.8342C18.3314 15.9652 16.5894 16.8737 14.7208 17.3821C13.3674 17.7426 11.9441 17.8568 10.5536 17.6693C9.23382 17.5035 7.96138 17.0736 6.75711 16.5196C4.69887 15.5378 2.83622 14.1609 1.24886 12.5271C1.10696 12.3971 1.01662 12.2207 1 12.0281V11.9914C1.01875 11.821 1.08097 11.6535 1.20753 11.5338C2.1983 10.4966 3.31009 9.5778 4.50029 8.77879C5.65597 8.01302 6.89262 7.35635 8.20854 6.91316ZM11.3798 7.56728C10.6235 7.6572 9.89135 7.94399 9.27771 8.39655C8.41905 9.01743 7.79433 9.95536 7.55527 10.9887C7.32217 11.9816 7.43808 13.0559 7.89277 13.9708C8.31891 14.8449 9.03865 15.571 9.9084 16.0057C10.7539 16.4352 11.7391 16.5763 12.6723 16.4135C13.5327 16.269 14.3424 15.8569 14.976 15.2586C15.6728 14.6024 16.1551 13.7181 16.3145 12.773C16.4692 11.8849 16.3499 10.9491 15.9672 10.1318C15.5965 9.33405 14.988 8.64754 14.235 8.19243C13.3908 7.66658 12.3655 7.45095 11.3798 7.56728Z",
    fill: "#5A5F72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1974 9.31235C10.777 8.94332 11.4784 8.76476 12.1636 8.82783C12.5782 8.85937 12.9784 8.99104 13.3513 9.1713C12.9098 9.49772 12.6008 10.0074 12.5586 10.5592C12.4853 11.2696 12.8557 11.9987 13.4676 12.3652C13.9351 12.6584 14.5278 12.7125 15.0511 12.5489C14.9177 13.3014 14.5125 14.0045 13.9167 14.4857C13.39 14.919 12.7197 15.1751 12.0375 15.1994C11.2704 15.2322 10.4953 14.9761 9.90125 14.4899C9.38648 14.0732 9.00381 13.4949 8.82994 12.8553C8.64415 12.1871 8.68548 11.4584 8.9467 10.8158C9.19301 10.2 9.63918 9.66903 10.1974 9.31235Z",
    fill: "#5A5F72"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.1516,
    y1: 3.27277,
    x2: 5.36368,
    y2: 5.48484,
    stroke: "#5A5F72",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20.404,
    y1: 2.45653,
    x2: 18.4192,
    y2: 4.87467,
    stroke: "#5A5F72",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.6344,
    y1: 0.750031,
    x2: 11.6344,
    y2: 3.87837,
    stroke: "#5A5F72",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 3.87834,
    y2: -0.75,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 2.09094 20.7273)",
    stroke: "#5A5F72",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 3.87834,
    y2: -0.75,
    transform: "matrix(-0.634432 -0.772979 -0.772979 0.634432 20.3 22.5991)",
    stroke: "#5A5F72",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 3.87834,
    y2: -0.75,
    transform: "matrix(-4.37121e-08 -1 -1 4.37106e-08 10.8844 24)",
    stroke: "#5A5F72",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewRxIcon);
export default __webpack_public_path__ + "static/media/ViewRxIcon.c4f958221455f21851569b1cc3a061ac.svg";
export { ForwardRef as ReactComponent };